module.exports = __webpack_public_path__ + "img/arabic.03482cf9.svg";